var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteCheckboxCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    stroke: "white",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.90909L6.64516 12L18 2",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheckboxCheck);
export default __webpack_public_path__ + "static/media/white-checkbox-check.80540eacd3474367412877d82e9c27bb.svg";
export { ForwardRef as ReactComponent };